import React, { FunctionComponent, useMemo } from 'react';

import { ConsolidatedCompSources } from '@/endpoints/itasca/comps/queryConsolidatedComps';
import {
  confidentialColor,
  contributoryColor,
  courthouseColor,
  curatedColor,
} from '@/mapbox-layers/comps';

interface IProps {
  compType: ConsolidatedCompSources;
}

function getCompDotColor(compType: ConsolidatedCompSources) {
  let backgroundColor = '';

  switch (compType) {
    case ConsolidatedCompSources.PRIVATE:
      backgroundColor = confidentialColor;
      break;
    case ConsolidatedCompSources.CONTRIBUTED:
      backgroundColor = contributoryColor;
      break;
    case ConsolidatedCompSources.CURATED:
      backgroundColor = curatedColor;
      break;
    case ConsolidatedCompSources.COURTHOUSE:
      backgroundColor = courthouseColor;
      break;
    default:
      break;
  }

  return backgroundColor;
}

const CompDot: FunctionComponent<IProps> = ({ compType }) => {
  const style = useMemo(() => {
    return {
      backgroundColor: getCompDotColor(compType),
    };
  }, [compType]);

  return <div className="h-3 w-3 rounded-full" style={style} />;
};

export default CompDot;
